import * as api from '../../api'
import * as authActions from '../actions/auth'
import * as userEffects from '../effects/user'

export const initSession = subscriber_id => (dispatch, getState) => {
  const userInfo = getState().user.userInfo.data
  dispatch(authActions.setSession({ subscriber_id }))

  if (!userInfo) {
    userEffects.getUserInfo()(dispatch)
  }

  userEffects.getAddresses()(dispatch)
  userEffects.getCards()(dispatch)
}

export const logIn = ({ email, password }) => dispatch => {
  dispatch(authActions.logIn())
  return api
    .logIn({ email, password })
    .then(res => {
      dispatch(authActions.logInSuccess(res))
      return { login: res, success: true }
    })
    .catch(err => {
      dispatch(authActions.logInFail(err))
      return { login: err, success: false }
    })
}

export const signUp = ({
  email,
  password,
  firstname,
  lastname
}) => dispatch => {
  dispatch(authActions.signUp())
  return api
    .signUp({ email, password, firstname, lastname })
    .then(res => {
      if (res.errors) {
        dispatch(authActions.signUpFail(res.errors))
        return { success: false, error: res.errors[0].message }
      }
      const userData = res.data.signUp
      dispatch(authActions.signUpSuccess(userData))
      return { success: true, userData }
    })
    .catch(error => {
      dispatch(authActions.signUpFail(error))
      return { success: false, error: error.graphQLErrors[0].message }
    })
}



// WEBPACK FOOTER //
// ./src/store/effects/auth.js